import { render } from "./TheHinhThucKinhDoanhCoSoDuoc.vue?vue&type=template&id=100d1676"
import script from "./TheHinhThucKinhDoanhCoSoDuoc.vue?vue&type=script&lang=js"
export * from "./TheHinhThucKinhDoanhCoSoDuoc.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__